import gql from 'graphql-tag';

export const filtersFragment = gql`
    fragment filterData on GraphQLMutualFund {
        broadAssetClass
        iClass
        morningStarRatings {
            morningStarOverallRating
            morningStarCategoryName
        }
        openToNewInvestors
        openToSubsequentInvestments
        redemptionFee
        riskLevel
        taxFree
        ticker
        name
        trpCode
        selectFund
    }
`;

export const FILTERS_QUERY = gql`
    query allMutualFunds {
        allMutualFunds {
            ...filterData
            shortName
            activeMoneyMarketFundMessages {
                message
                messageType
                trpCode
                liquidityFeePercent
                eventPeriodType
            }
        }
    }
    ${filtersFragment}
`;

export const ETF_FILTERS_QUERY = gql`
    query allExchangeTradedFunds {
        allExchangeTradedFunds {
            name
            ticker
            trpCode
            assetClassName
            broadAssetClass
            publicOfferingDate
            morningStarCategoryName
        }
    }
`;
